
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import errorHandlingMiddleware from '../common/middleware/errorHandlingMiddleware';
import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import reducers from 'main/reducers';
import DevTools from '../common/components/DevTools';

export default function configureStore(state = {}) {
    return createStore(
        reducers,
        state,
        compose(
            applyMiddleware(
                errorHandlingMiddleware,
                thunk,
                routerMiddleware(browserHistory)),
            window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : DevTools.instrument()
        )
    );
}
